<template>
  <div class="d-flex align-center">
    <v-chip-group v-model="selectedItemId" column :active-class="`${theme.elements.btnColor} ${theme.elements.btnTextClz}`">
      <v-chip small v-for="(label, n) in sortedLabels" :key="n" :value="label.id" filter>
        {{ label[displayProperty] }}
      </v-chip>
    </v-chip-group>
    <v-btn
      class="d-flex caption justify-center"
      v-if="displayFilterIcon"
      :disabled="!selectedItemId"
      rounded
      icon
      color="accent"
      @click="selectedItemId = null"
    >
      <v-icon>mdi-{{ selectedItemId ? 'filter-off' : 'filter' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import common from '@/mixins/common';

export default {
  name: 'Labels',
  mixins: [common],
  props: {
    labels: Array,
    displayFilterIcon: Boolean,
    displayProperty: String,
    value: Number,
  },
  data() {
    return {
      selectedItemId: this.value,
    };
  },
  computed: {
    sortedLabels() {
      return [...(this.labels || [])].sort((a, b) => Number(a.sort) - Number(b.sort));
    },
  },
  watch: {
    selectedItemId(newValue, oldValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
